import React from 'react';

import { EvIcon, EvSection } from '@evinced-private/ui-common';

import { defaultErrorsData, ERROR_TYPE } from '../../types/chartErrors';

import './ErrorView.scss';

interface ErrorViewProps {
	errorType: ERROR_TYPE | null;
	className?: string;
}

const renderErrorState = ({ errorType, className = '' }: ErrorViewProps): React.ReactNode => {
	if (!errorType) {
		return null;
	}

	const errorData = defaultErrorsData[errorType];

	if (!errorData) {
		return null;
	}

	const { title, description, icon: iconString } = errorData;

	const renderDescription = (): React.ReactNode => {
		if (Array.isArray(description)) {
			return (
				<div className="error-view-description">
					{description.map((line) => (
						<p
							key={`error-line-${line.slice(0, 30).replace(/\s/g, '-')}`}
							className="error-view-description-line"
						>
							{line}
						</p>
					))}
				</div>
			);
		}

		return <p className="error-view-description">{description}</p>;
	};

	const errorViewClassName = `error-view ${className}`.trim();

	return (
		<EvSection className={errorViewClassName}>
			<div className="error-view-content">
				<div className="error-view-icon">
					<EvIcon icon={iconString} />
				</div>
				<div className="error-view-text">
					<h3 className="error-view-title">{title}</h3>
					{renderDescription()}
				</div>
			</div>
		</EvSection>
	);
};

export const ErrorView: React.FC<ErrorViewProps> = (props) => {
	return renderErrorState(props) as React.ReactElement;
};
